import { useEffect } from 'react';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useNotificationStore } from '@/shared/api/notificationStore';

const STORAGE_KEY = 'vm_pending_notification';

export function queueNotification(message: string, severity: 'error' | 'warning' | 'info' | 'success' = 'error', title?: string) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ message, severity, title }));
}

export function AppNotification() {
  const { title, message, severity, clear, show } = useNotificationStore();

  // Drain any notification queued before a full-page redirect (e.g. from DjRoute
  // before navigating to /logout, which goes through Cognito and back).
  useEffect(() => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      sessionStorage.removeItem(STORAGE_KEY);
      try {
        const { message: msg, severity: sev, title: ttl } = JSON.parse(raw) as { message: string; severity: 'error' | 'warning' | 'info' | 'success'; title?: string };
        show(msg, sev, ttl);
      } catch { /* malformed entry — ignore */ }
    }
  }, [show]);

  return (
    <Snackbar
      open={!!message}
      autoHideDuration={5000}
      onClose={clear}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        '&.MuiSnackbar-anchorOriginTopCenter': {
          top: '50vh',
          transform: 'translate(-50%, -50%)',
        },
      }}
    >
      <Alert onClose={clear} severity={severity} variant="filled" sx={{ minWidth: 360, maxWidth: 480 }}>
        {title && <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
}
